import { Skeleton } from '@/components/ui/skeleton';

interface SettingsFormSkeletonProps {
  rows?: number;
}

export function SettingsFormSkeleton({ rows = 6 }: SettingsFormSkeletonProps) {
  return (
    <div className="flex flex-col gap-4">
      {Array.from({ length: rows }).map((_, index) => (
        <div key={index} className="flex items-center gap-1">
          <Skeleton className="h-5 w-1/3 shrink-0" />
          <Skeleton className="h-10 flex-1" />
        </div>
      ))}
      <Skeleton className="mt-2 h-10 w-32" />
    </div>
  );
}

export function IssueSettingsSkeleton() {
  return (
    <div className="flex flex-col gap-4">
      {/* Categories section */}
      <div className="flex gap-2">
        <Skeleton className="h-5 w-[230px] shrink-0" />
        <div className="flex flex-col gap-2">
          <div className="flex flex-wrap gap-1">
            {Array.from({ length: 4 }).map((_, index) => (
              <Skeleton key={index} className="h-6 w-20 rounded-full" />
            ))}
          </div>
          <Skeleton className="h-9 w-36" />
        </div>
      </div>
      {/* Tags section */}
      <div className="flex gap-2">
        <Skeleton className="h-5 w-[230px] shrink-0" />
        <div className="flex flex-col gap-2">
          <div className="flex flex-wrap gap-1">
            {Array.from({ length: 3 }).map((_, index) => (
              <Skeleton key={index} className="h-6 w-16 rounded-full" />
            ))}
          </div>
          <Skeleton className="h-9 w-28" />
        </div>
      </div>
      <Skeleton className="h-10 w-32" />
    </div>
  );
}

export function DocumentSettingsSkeleton() {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-2">
        <Skeleton className="h-5 w-[230px] shrink-0" />
        <div className="flex flex-col gap-2">
          <div className="flex flex-wrap gap-1">
            {Array.from({ length: 4 }).map((_, index) => (
              <Skeleton key={index} className="h-6 w-20 rounded-full" />
            ))}
          </div>
          <Skeleton className="h-9 w-36" />
        </div>
      </div>
      <Skeleton className="h-10 w-32" />
    </div>
  );
}

export function ScheduleSettingsSkeleton() {
  return (
    <div className="flex flex-col gap-4">
      <Skeleton className="h-5 w-12" />
      <div className="flex flex-col gap-2">
        <Skeleton className="h-40 rounded-lg" />
        <Skeleton className="h-10 w-24" />
      </div>
      <div className="flex w-full items-start gap-4">
        <Skeleton className="h-5 w-[350px] shrink-0" />
        <div className="flex min-w-px flex-1 flex-col gap-2">
          <div className="flex flex-wrap gap-1">
            {Array.from({ length: 3 }).map((_, index) => (
              <Skeleton key={index} className="h-5 w-16 rounded" />
            ))}
          </div>
          <Skeleton className="h-10 w-28" />
        </div>
      </div>
      <div className="flex w-full items-center gap-4">
        <Skeleton className="h-5 w-[350px] shrink-0" />
        <Skeleton className="h-4 w-8 rounded-full" />
      </div>
      <Skeleton className="h-10 w-32" />
    </div>
  );
}

export function WorkOrderSettingsSkeleton() {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-2">
        <Skeleton className="h-5 min-w-[230px]" />
        <div className="flex flex-col gap-2">
          <div className="flex flex-wrap gap-1">
            {Array.from({ length: 3 }).map((_, index) => (
              <Skeleton key={index} className="h-5 w-16 rounded" />
            ))}
          </div>
          <Skeleton className="h-10 w-28" />
        </div>
      </div>
      <Skeleton className="h-10 w-32" />
    </div>
  );
}

export function NotificationsTabSkeleton() {
  return (
    <div className="flex flex-col gap-4">
      <Skeleton className="h-10 w-full" />
      <div className="mt-6 flex flex-col gap-4">
        <Skeleton className="h-6 w-48" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-32 w-full rounded-md" />
        <Skeleton className="h-10 w-28" />
      </div>
    </div>
  );
}
